import { render, staticRenderFns } from "./Template220.vue?vue&type=template&id=2c26c394"
import script from "./Template220.vue?vue&type=script&lang=js"
export * from "./Template220.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c26c394')) {
      api.createRecord('2c26c394', component.options)
    } else {
      api.reload('2c26c394', component.options)
    }
    module.hot.accept("./Template220.vue?vue&type=template&id=2c26c394", function () {
      api.rerender('2c26c394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Template220.vue"
export default component.exports